import { render, staticRenderFns } from "./loding.vue?vue&type=template&id=7f5d99d1&scoped=true&"
import script from "./loding.vue?vue&type=script&lang=js&"
export * from "./loding.vue?vue&type=script&lang=js&"
import style0 from "./loding.vue?vue&type=style&index=0&id=7f5d99d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d99d1",
  null
  
)

export default component.exports